export default __webpack_public_path__ + "static/media/hlb-icon.4e1ab1d9.svg";